import Vue from "vue";
import axios from "axios";

const axiosIns = axios.create({
  baseURL: "https://b2bapi.d7ksuper.com/api/",
});


Vue.prototype.$http = axiosIns;

export default axiosIns;
